module.exports = __webpack_public_path__ + "static/media/title_line.0e7ad47a.svg";